import {HeaderMenuGiftDefaultBox} from "./header-menu-gift.default.box";

export const HeaderMenuGiftBox = HeaderMenuGiftDefaultBox;